import { findAll } from './findAll';

export const genreActions = {
  findAll,
};
